<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="请输入配置名称"
        class="!w-200px mr-10px"
        v-model="keyword"
      />
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button size="small" type="primary" @click="toDetail('create')">新增</el-button>
      <el-button size="small" type="danger" @click="batchDelete(selection)">删除</el-button>
      <!-- <el-button size="small" @click="openUploadDialog"
        >导入</el-button
      > -->
    </div>
    <el-table
      height="calc(100% - 106px)"
      class="mt-20px"
      border
      stripe
      :data="tableData"
      @selection-change="selectionChange"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="60" align="center"></el-table-column>
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="配置名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="系统名称" prop="systemName" show-overflow-tooltip></el-table-column>
      <el-table-column label="是否启用" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isEnable"
            @change="enableConfig(scope.row)"
            :disabled="scope.row.isEnable"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="creatorName" width="120"> </el-table-column>
      <el-table-column label="创建时间" prop="creationTime" width="180"> </el-table-column>
      <el-table-column width="195" label="操作">
        <template slot-scope="scope">
          <el-button @click="toDetail('read', scope.row)" size="mini">查看</el-button>
          <el-button size="mini" @click="toDetail('update', scope.row)">编辑</el-button>
          <el-button size="mini" @click="batchDelete([scope.row])">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="text-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <!-- <wiz-upload-file
      v-dialogDrag
      @refreshList="searchList()"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file> -->
  </el-card>
</template>

<script>
import { SystemSettingApi } from '@wiz-api/workbench'
import FnMixins from '@/assets/js/fnMixins'
import dayjs from 'dayjs'

const systemSettingApi = new SystemSettingApi()

export default {
  name: 'systemConfig',
  mixins: [FnMixins],
  data() {
    return {
      keyword: '',
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      selection: [],
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      tableLoading: false,
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.tableLoading = true
      const [err, res] = await systemSettingApi.getSystemSettingPage(
        this.page.pageNo,
        this.page.pageSize,
        { name: this.keyword }
      )
      this.tableLoading = false
      if (!err) {
        this.tableData = res.items.map((it) => {
          it.creationTime = dayjs(it.creationTime).format('YYYY-MM-DD HH:mm:ss')
          return it
        })
        this.page.pageTotal = res.totalCount
      }
    },
    toDetail(type, row) {
      const query = {
        type,
      }
      if (row) query.id = row.id
      this.$router.push({
        path: `${this.routerBase}/portal-management/system-management/system-config-detail`,
        query,
      })
    },
    selectionChange(selection) {
      this.selection = selection
    },
    batchDelete(data) {
      if (data.length === 0) {
        this.$message.warning('请选择需要删除的数据')
        return
      }
      const isEnableData = _.find(data, { isEnable: true })
      if (isEnableData) {
        this.$message.warning('不可删除启用配置，请先禁用')
        return
      }
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await systemSettingApi.deleteSystemSetting({
            body: _.map(data, (it) => {
              return it.id
            }),
          })
          if (!err) {
            this.$message.success('删除成功')
            this.searchList()
          }
        })
        .catch(() => {})
    },
    // 启用配置
    enableConfig(row) {
      this.$confirm('是否启用当前配置', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await systemSettingApi.startSystemSetting(row.id)
          if (!err) {
            this.$message.success('启用成功')
            this.findList()
          }
        })
        .catch(() => {
          row.isEnable = !row.isEnable
        })
    },
    openUploadDialog() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      // const [err, res] = await dataApi.getTemplateExcelFile()
      // // 返回的是文件流
      // if (!err) {
      //   this.downLoadBlob({
      //     name: '数据字典模板.xlsx',
      //     data: res,
      //   })
      // }
    },
    // 上传文件
    async importTemplate(file) {
      // this.uploadFileProps.btnLoading = true
      // const formData = new FormData()
      // _.forIn({ file }, (value, key) => {
      //   formData.append('excelFile', value)
      // })
      // const [err, res] = await dataApi.importFromExcelFile({
      //   excelFile: file,
      // })
      // if (!err) {
      //   this.uploadFileProps.active = 2
      //   this.$message.success(this.$t('theImportToExcelIsSuccessful'))
      // }
      // this.uploadFileProps.btnLoading = false
    },
    // 下载导入结构
    exportResults() {},
  },
  created() {
    this.findList()
  },
}
</script>

<style lang="scss" scoped></style>
